export const authPaths = {
  authResponse: '/auth-response'
};

export const partnerLandingPaths = {
  home: '/',
  saleHandoff: '/sale-handoff/:data',
  voicesalesAcquisition: '/voicesales-acquisitions',
  voiceSalesWinback: '/voicesales-winback',
  voiceSalesHomeMove: '/voicesales-homemove',
  nondomesticTransfer: '/nondomestic-transfer',
  retrieveQuote: '/retrieve-quote/:quoteId',
  awin: '/?source=aw',
  raf: '/?bp_e=:rafToken',
  moveIn: '/move-in',
  heatPumpRegistration: '/heat-pump-registration',
  solarRegistration: '/solar-saver-registration',
  tariffInformation: '/tariff-information',
  abandonedCart: '/abandoned-cart/:quoteId'
};

export const routePath = {
  energyNeeds: '/energy-needs',
  personalDetails: '/personal-details',
  peakSave: '/peak-save',
  businessUpdatesAnnouncement: '/business-updates/announcement',
  personaliseQuote: '/personalise-quote',
  findAddress: '/find-address',
  fuelType: '/fuel-type',
  newHome: '/new-home',
  meterReads: '/meter-reads',
  meterpointValidation: '/meterpoint-validation',
  meterpointGuide: '/meterpoint-guide/:type(MPAN|MPRN|MPAN-MPRN)',
  gasMeter: '/gas-meter',
  mixedMeters: '/mixed-meters',
  prepayInfo: '/payment-method',
  consumptionEntry: '/consumption-entry',
  quote: '/quote',
  tariffDetails: '/tariff-details',
  emailQuote: '/email-quote/:productCode',
  createAccount: '/create-account',
  directDebitType: '/direct-debit-type',
  directDebit: '/direct-debit',
  psrEntry: '/psr-entry',
  userPreferences: '/marketing-preferences',
  orderSummary: '/order-summary',
  orderComplete: '/order-complete',
  heatPumpConfirmation: '/heat-pump-confirmation',
  solarConfirmation: '/solar-saver-confirmation',
  quoteExpired: '/quote-expired',
  exceptions: '/exceptions',
  splitSupply: '/split-supply',
  classicSupply: '/classic-supply',
  nonSupply: '/non-supply',
  moveDate: '/move-date',
  meterRead: '/meter-read',
  selectOptions: '/select-options',
  evTariffInformation: '/ev-tariff-information',
  emailCapture: '/email-capture',
  quoteExpiredAbandonedCart: '/abandoned-cart/quote-expired',
  ...partnerLandingPaths,
  ...authPaths
};
